/**
 * PlayerSourceSelector Container Component
 *
 * Manages state for player source selection (watchlist vs roster).
 * Thin container that passes through props to the view component.
 */

import React from "react";

import PlayerSourceSelectorView, {
  PlayerSource,
} from "./PlayerSourceSelectorView";

/**
 * Props for PlayerSourceSelector container
 */
interface PlayerSourceSelectorContainerProps {
  selectedSource: PlayerSource;
  onSourceChange: (source: PlayerSource) => void;
}

/**
 * Container component for selecting the player data source between watchlist and roster.
 * @param root0 - The component props
 * @param root0.selectedSource - The currently selected player source (watchlist or roster)
 * @param root0.onSourceChange - Callback invoked when the player source selection changes
 */
const PlayerSourceSelectorContainer = ({
  selectedSource,
  onSourceChange,
}: PlayerSourceSelectorContainerProps) => {
  const handleSelectWatchlist = React.useCallback(
    () => onSourceChange("watchlist"),
    [onSourceChange]
  );

  const handleSelectRoster = React.useCallback(
    () => onSourceChange("roster"),
    [onSourceChange]
  );

  return (
    <PlayerSourceSelectorView
      selectedSource={selectedSource}
      onSelectWatchlist={handleSelectWatchlist}
      onSelectRoster={handleSelectRoster}
    />
  );
};

export default PlayerSourceSelectorContainer;
